import React from 'react';
import { Grid, InputLabel, Box, Chip } from '@material-ui/core';
import useStyles from './styles';
import { getTagLabel } from './tags';

const Tag = ({ tag }) => {
  const classes = useStyles();
  if (!tag) return (<></>);
  return (
    <Grid item xs={12}>
      <InputLabel className={classes.inputLabel}>  Tag </InputLabel>
      <Box>
        <Chip
          label={getTagLabel(tag)}
          key={tag}
          color="primary"
          size="small"
          className={classes.chip}
        />
      </Box>
    </Grid>
  );
};

export default React.memo(Tag);
